import { useAuth } from '@clerk/clerk-react';
import axios, { type AxiosInstance, AxiosRequestConfig } from 'axios';

export const useApiClient = (): AxiosInstance => {
  const { getToken } = useAuth();

  const apiClient = axios.create({
    baseURL: import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000/api',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  // Add auth token to requests
  apiClient.interceptors.request.use(async (config) => {
    const token = await getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  });

  // Handle response errors
  apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
      console.error('API Error:', error);
      return Promise.reject(error);
    },
  );

  return apiClient;
};
